export const BASE_PATH = process.env.REACT_APP_API_URL || "https://result.sod-af.com";
export const GET_REWARD_LOTTO = "/result/active";
export const GET_HISTORY_REWARD_LOTTO = "/result/history";
